import { useEffect, useRef } from 'react'

const useScrollDepthAnalytic = (
  scrollDepthTriggerPoints: number[],
  eventCallback: (depth: number, pageTitle?: string, scrollDirection?: string) => void
) => {
  const triggeredDepths = useRef<boolean[]>(scrollDepthTriggerPoints.map(() => false))
  const prevScrollY = useRef<number>(0)
  useEffect(() => {
    const handleScroll = () => {
      if (typeof window === 'undefined') return
      const scrolledDepth = Math.min(
        1,
        (window.innerHeight + window.scrollY) / document.body.offsetHeight
      )

      const scrollDirection = window.scrollY > prevScrollY.current ? 'down' : 'up'
      const pageTitle =
        document.querySelector('[data-title]')?.getAttribute('data-title') ||
        document.title ||
        'data-title not found'
      scrollDepthTriggerPoints.forEach((depth, index) => {
        if (
          scrollDirection === 'down' &&
          scrolledDepth >= depth &&
          !triggeredDepths.current[index]
        ) {
          eventCallback(depth, pageTitle, scrollDirection)
          triggeredDepths.current[index] = true
        }

        if (scrollDirection === 'up' && scrolledDepth < depth && triggeredDepths.current[index]) {
          eventCallback(depth, pageTitle, scrollDirection)
          triggeredDepths.current[index] = false
        }
      })
      if (window.scrollY === 0) {
        triggeredDepths.current = scrollDepthTriggerPoints.map(() => false)
      }
      prevScrollY.current = window.scrollY
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll)
      return () => {
        window.addEventListener('scroll', handleScroll)
      }
    }
  }, [scrollDepthTriggerPoints, eventCallback])
}

export default useScrollDepthAnalytic
